import { FORGOT_PASSWORD } from '../actionTypes'

export const forgotPassword = (email: string) => ({
  type: FORGOT_PASSWORD.name,
  api: {
    url: 'user/forgot_password',
    data: { email },
  },
})
